import { Injectable, inject } from '@angular/core';
import { Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UsuarioService } from '../services/auth/usuario.service';
import { CustomMessageService } from '../services/utils/message.service';
import { obtenerObjDeJSON } from '../utils/object-utils';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard {
  
  private router = inject(Router);
  private usuarioService = inject(UsuarioService);
  private messageService = inject(CustomMessageService);

  canActivate(_route: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    const validSession = this.usuarioService.verificarCaducudadToken();
    const usuarioJson = localStorage.getItem('usuario');
    
    if (!validSession || !usuarioJson) {
      this.usuarioService.logout();
      this.messageService.alert('La sesión ha caducado. Inicia sesión de nuevo.');
      return this.router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
    }

    const usuarioObj = obtenerObjDeJSON(usuarioJson);
    const usuarioTieneAccesoOperativo = ['ADMIN', 'EMPLEADO'].includes(usuarioObj?.rol);

    if (usuarioTieneAccesoOperativo) {
      return true;
    } else {
      this.messageService.alert('No tienes permisos para acceder a la gestión operativa');
      return this.router.createUrlTree(['/home']);
    }
  }
}
